/* eslint-disable jsx-a11y/anchor-is-valid */
import globalStyles from "../../../../assets/styles/base/globalPage.module.scss";
import styles from "./styles.module.scss";
import { useSmsCampaignAudienceForm } from "./useSmsCampaignAudienceForm";
import { ContactList } from "./ContactList";
import { SegmentedList } from "./SegmentedList";
import { AudienceSummary } from "./AudienceSummary";
import { ManualList } from "./ManualList";

export const SmsCampaignAudienceForm = ({ smsCampaign = {} }) => {
  const {
    formData,
    audienceTypes,
    currentAuidence,
    isSubmiting,
    setFormData,
    setCurrentAuidence,
    handleSubmitAudience,
  } = useSmsCampaignAudienceForm({ smsCampaign });

  return (
    <>
      <div className={styles.smsCampaignAudienceForm}>
        <div className={styles.smsCampaignAudienceForm__left}>
          <div>
            <h5>Select Audience</h5>
            <p>
              Choose the target group or individuals that will receieve this
              campaign
            </p>
          </div>

          <div
            className={` ${globalStyles["cardWithBackground"]} ${styles.body}`}
          >
            <nav className={globalStyles.rowNavigations}>
              {audienceTypes?.map((item, index) => {
                const icon = item?.icon;
                return (
                  <a
                    key={index}
                    className={`${globalStyles.rowNavigations__item} ${
                      currentAuidence === item?.id ? globalStyles.active : ""
                    } w-50`}
                    onClick={() => setCurrentAuidence(item?.id)}
                  >
                    {icon} {item?.name}
                  </a>
                );
              })}
            </nav>

            {currentAuidence === "phone_book" ? (
              <ContactList formData={formData} setFormData={setFormData} />
            ) : currentAuidence === "automated" ? (
              <SegmentedList
                formData={formData}
                setFormData={setFormData}
                smsCampaign={smsCampaign}
              />
            ) : (
              <ManualList formData={formData} setFormData={setFormData} />
            )}
          </div>
        </div>

        <div className={`${styles.smsCampaignAudienceForm__right}`}>
          <AudienceSummary
            formData={formData}
            isSubmitting={isSubmiting}
            onSubmit={handleSubmitAudience}
          />
        </div>
      </div>
    </>
  );
};
